import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import { TextValidator } from "react-material-ui-form-validator";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Lang from "../../Utils/lang";
import style from "../Form.module.scss";

const lang = Lang.getInstance();

const options = [
  {
    id: 1,
    label: "Lunar",
  },
  {
    id: 2,
    label: "Trimestrial",
  },
  {
    id: 3,
    label: "Anual",
  },
  {
    id: 4,
    label: "Altul",
  },
];

function SepticTruckIntrerval({
  systemDataCollection,
  form,
  setSystemDataCollection,
  setForm,
}) {
  const [selected, setSelected] = useState([]);
  const [others, setOthers] = useState("");

  /**
   *
   */
  useEffect(() => {
    if (systemDataCollection.septicTruckInterval) {
      let newName = systemDataCollection.septicTruckInterval.split(",");
      for (let i = 0; i < newName.length; i++) {
        if (newName[i].includes("_")) {
          const other = newName[i].split("_");
          other.shift();
          setOthers(other.join(""));
        }
        newName[i] = newName[i].trim();
      }
      setSelected(newName);
    }
  }, [systemDataCollection.septicTruckInterval]);

  /**
   *
   * @param {*} event
   * change checkbox
   */
  const handleChange = (event) => {
    let value = event.target.name;
    let newSelected = selected.slice();
    let newSystemDataCollection = Object.assign({}, systemDataCollection);
    const find = newSelected.findIndex((s) => s === value || s.includes(value));
    if (find >= 0) {
      newSelected.splice(find, 1);
      setSelected(newSelected);
      newSystemDataCollection.septicTruckInterval = newSelected.join();
      setSystemDataCollection(newSystemDataCollection);
      setForm({ ...form, systemDataCollection: newSystemDataCollection });
    } else {
      if (value === "Altul") {
        newSelected.push(`${value}_${others}`);
        setSelected(newSelected);
        newSystemDataCollection.septicTruckInterval = newSelected.join();
        setSystemDataCollection(newSystemDataCollection);
        setForm({ ...form, systemDataCollection: newSystemDataCollection });
      } else {
        newSelected.push(value);
        setSelected(newSelected);
        newSystemDataCollection.septicTruckInterval = newSelected.join();
        setSystemDataCollection(newSystemDataCollection);
        setForm({ ...form, systemDataCollection: newSystemDataCollection });
      }
    }
  };

  /**
   *daca este bifat "altul" se salveaza si textul din textfield
   */

  function onChangeSelected() {
    let newSystemDataCollection = Object.assign({}, systemDataCollection);
    let newSelected = selected.slice();
    const index = newSelected.findIndex((s) => s.includes("Altul"));
    if (index >= 0) {
      newSelected[index] += `_${others}`;
      setSelected(newSelected);
      newSystemDataCollection.septicTruckInterval = newSelected.join();
      setSystemDataCollection(newSystemDataCollection);
      setForm({ ...form, systemDataCollection: newSystemDataCollection });
    }
  }

  return (
    <FormControl style={{ marginTop: 15 }}>
      <FormLabel className={style.formLabel}>Intervalul de vidanjare</FormLabel>
      {options
        ? options.map((option) =>
            option.label.includes("Altul") ? (
              <>
                <div style={{ display: "flex" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={option.label}
                        checked={
                          selected.find((op) => op.includes(option.label))
                            ? true
                            : false
                        }
                        onChange={(e) => handleChange(e)}
                      />
                    }
                    label={option.label}
                  />
                  <TextValidator
                    type="text"
                    name="others"
                    variant="standard"
                    fullWidth
                    disabled={!selected.find((op) => op.includes(option.label))}
                    value={others}
                    validators={
                      selected.find((op) => op.includes(option.label))
                        ? ["required"]
                        : []
                    }
                    errorMessages={
                      selected.find((op) => op.includes(option.label))
                        ? [lang.get("textFieldRequired")]
                        : []
                    }
                    onChange={(event) => setOthers(event.target.value)}
                    onBlur={() => onChangeSelected()}
                  />
                </div>
              </>
            ) : (
              <>
                <FormControlLabel
                  control={
                    <Checkbox
                      name={option.label}
                      checked={selected.indexOf(option.label) > -1}
                      onChange={(e) => handleChange(e)}
                    />
                  }
                  label={option.label}
                />
              </>
            )
          )
        : ""}
    </FormControl>
  );
}

export default SepticTruckIntrerval;
SepticTruckIntrerval.propTypes = {
  systemDataCollection: PropTypes.object,
  form: PropTypes.object,
  setSystemDataCollection: PropTypes.func,
  setForm: PropTypes.func,
};
